export default __webpack_public_path__ + "static/media/img-0564-finland-full-face.0db3e89b.png";